import React, { Component } from 'react';

//componentes
import Superior from './superior'

class Index extends Component {

    render(){
        return(
            <div>
                <Superior />
            </div>
        );
    }

}
export default Index;